import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "D:\\wwwroot\\dealer-web\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\wwwroot\\dealer-web\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\wwwroot\\dealer-web\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\wwwroot\\dealer-web\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
// Vue
import Vue from 'vue';
import i18n from './i18n';
import App from './App'; // 核心插件

import d2Admin from '@/plugin/d2admin'; // store

import store from '@/store/index';
import util from '@/libs/util.js'; // 菜单和路由设置

import router from './router';
import { menuHeader, menuAside, loadMenuAside } from '@/menu';
import { frameInRoutes } from '@/router/routes';
import versionTood from '@/libs/util.versionupdate';
import { preventReClick } from './preventReClick';
import audio from 'vue-mobile-audio'; // 全局样式

import '@/assets/style/global.scss'; // 引入样式

import 'vue-easytable/libs/theme-default/index.css'; // 引入组件库

import { VeTable } from 'vue-easytable';
import '@/assets/directive/int.js';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
Vue.use(VeTable);
Vue.use(audio); // 核心插件

Vue.use(d2Admin);
Vue.use(preventReClick);
Vue.directive('enterNumber', {
  // 当被绑定的元素插入到 DOM 中时
  inserted: function inserted(el, binding, vnode) {
    el.addEventListener('keyup', function (e) {
      var val = e.target.value;
      var arg = binding.value || binding.arg;
      val = val.toString().replace(/[^\d^.-]+/g, '').replace(/^\./g, '').replace(/^(-)|-+/g, '$1').replace(/^([^.]*\.)|\.+/g, '$1');

      if (val && val !== '-') {
        if (arg.hasOwnProperty('min')) {
          if (Number(val) < Number(arg.min)) {
            val = arg.min;
          }
        }

        if (arg.hasOwnProperty('max')) {
          if (Number(val) > Number(arg.max)) {
            val = arg.max;
          }
        }

        if (arg.hasOwnProperty('precision')) {
          if (parseInt(arg.precision) === 0) {
            val = parseInt(val);
          } else {
            var reg = new RegExp('^(\\d{10})\\d+|((\\.\\d{' + arg.precision + '})\\d+)$', 'g');
            val = val.toString().replace(reg, '$1$3'); // val = Number(val)
          }
        } else {
          var _reg = new RegExp('^(\\d{10})\\d+|((\\.\\d{2)\\d+)$', 'g');

          val = val.toString().replace(_reg, '$1$3');
          val = Number(val);
        }
      }

      vnode.data.model.callback(val);
    });
  }
});
Vue.directive('tableFit', {
  // 指令所在组件的 VNode 及其子 VNode 全部更新后调用。
  componentUpdated: function componentUpdated(el, binding, vnode) {
    setTimeout(function () {
      adjustColumnWidth(el, vnode);
    }, 0);
  }
});

function adjustColumnWidth(table, vnode) {
  // 中文和全角正则
  var CN = new RegExp("[\u4E00-\u9FA5]|[^\uFF00-\uFFFF]");
  var NUM = new RegExp('[0-9]'); // 中文字体的像素宽度比例

  var CN_RATE = 1.1; // 数字字体的像素宽度比例

  var NUM_RATE = 0.65; // 其他字体的像素宽度比例

  var OTHER_RATE = 0.5;
  var columns = vnode.child.columns.slice(); // el-table通过colgroup标签设置html宽度

  var colgroup = table.querySelector('colgroup');

  var colDefs = _toConsumableArray(colgroup.querySelectorAll('col')); // 忽略 设置了宽度 序号 多选框 的列
  // 判断gutter是否已存在


  var gutter = colgroup.querySelector('col[name=gutter]');
  var gutterx = colgroup.querySelector('col[name=gutterx]');
  var except = 0;

  if (gutter || gutterx) {
    // 删除gutter
    colDefs.pop();
  } // 若有序号 多选框则删除


  except = colDefs.length - columns.length;
  colDefs.splice(0, except);

  for (var i = columns.length - 1; i >= 0; i--) {
    if (columns[i].width) {
      colDefs.splice(i, 1);
      columns.splice(i, 1);
    }
  } // 设置每列宽度


  colDefs.forEach(function (col, index) {
    // colgroup中 和 表头标签的class名相同 通过class寻找相同列
    var clsName = col.getAttribute('name');
    var cells = [].concat(_toConsumableArray(table.querySelectorAll(".el-table__body-wrapper td.".concat(clsName))), _toConsumableArray(table.querySelectorAll("th.".concat(clsName))));
    var widthList = cells.map(function (el) {
      var cell = el.querySelector('.cell');

      if (cell) {
        var fontSize = parseInt(window.getComputedStyle(cell, null).fontSize);
        fontSize = fontSize || 14;
        var width = 0; // 计算每个字符的宽度

        var _iterator = _createForOfIteratorHelper(cell.innerText),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var str = _step.value;

            if (CN.test(str)) {
              width += fontSize * CN_RATE;
            } else if (NUM.test(str)) {
              width += fontSize * NUM_RATE;
            } else {
              width += fontSize * OTHER_RATE;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return Math.ceil(width);
      } else {
        return 0;
      }
    }); // 取一列中的最大宽度

    var max = Math.max.apply(Math, _toConsumableArray(widthList));

    if (max !== 0) {
      // 在表格数据中设置minWidth 防止尺寸变化重新计算原来的宽度
      // 20 + 2  20 是cell类的padding 2 是给予额外空间
      columns[index].minWidth = max + 22;
      table.querySelectorAll("col[name=".concat(clsName, "]")).forEach(function (el) {
        el.setAttribute('width', max + 22);
      });
    }
  }); // 设置完后调用el-table方法更新布局

  vnode.child.doLayout();
  tableRevise(table);
} // 修正el-table错位


function tableRevise(table) {
  var tableWrapper = table.querySelector('.el-table__body-wrapper');
  var tableBody = table.querySelector('.el-table__body');
  var colgroup = table.querySelector('colgroup');
  /**
   * (以下数值为滚动条高度，可以自己根据情况通过class重新修改)
   */
  // 内容大于容器时

  if (tableBody.clientWidth > tableWrapper.offsetWidth) {
    // 设置x轴滚动
    tableWrapper.style.overflowX = 'auto'; // 解决固定列错位 （没有错位的可以忽略以下内容）

    var fixedWrap = table.querySelectorAll('.el-table .el-table__fixed-body-wrapper');

    if (fixedWrap.length > 0) {
      fixedWrap.forEach(function (item) {
        item.style.paddingBottom = 15 + 'px';
      });
    } // 解决固定列覆盖滚动条


    var fixedLeft = table.querySelector('.el-table .el-table__fixed');
    var fixedRight = table.querySelector('.el-table .el-table__fixed-right');

    if (fixedLeft) {
      fixedLeft.style.height = 'calc(100% - 15px)';
    }

    if (fixedRight) {
      fixedRight.style.height = 'calc(100% - 15px)';
    } // 解决表头偏移
    // 没有原生的gutter时自己新增一个


    var gutter = colgroup.querySelector('col[name=gutter]');
    var gutterx = colgroup.querySelector('col[name=gutterx]');

    if (!gutter && !gutterx) {
      var col = document.createElement('col');
      col.setAttribute('name', 'gutterx');
      col.setAttribute('width', '15');
      colgroup.appendChild(col);
    }
  }
}

new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 处理路由 得到每一级的路由设置
              _this.$store.commit('d2admin/page/init', frameInRoutes); // 设置顶栏菜单


              _this.$store.commit('d2admin/menu/headerSet', menuHeader); // 初始化菜单搜索功能
              // this.$store.commit('d2admin/search/init', menuHeader)


            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    // 展示系统信息
    // this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load'); // 获取并记录用户 UA

    this.$store.commit('d2admin/ua/get'); // 初始化全屏监听

    this.$store.dispatch('d2admin/fullscreen/listen');

    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
      versionTood.isNewVersion();
    }
  },
  watch: {
    // 检测路由变化切换侧边栏内容
    '$route.matched': {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(matched, matched2) {
          var token, _side, _side2;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  token = util.cookies.get('token');

                  if (!token) {
                    _context2.next = 8;
                    break;
                  }

                  if (!(menuAside.length < 1)) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return loadMenuAside();

                case 5:
                  this.$store.commit('d2admin/menu/headerSet', menuHeader);

                  if (matched.length > 0) {
                    if (matched.length > 1) {
                      if (matched[1].path === '/index') {
                        this.$store.commit('d2admin/menu/asideSet', menuAside);
                      } else {
                        _side = menuAside.filter(function (menu) {
                          return menu.path === matched[0].path;
                        });
                        this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : []);
                      }
                    } else {
                      _side2 = menuAside.filter(function (menu) {
                        return menu.path === matched[0].path;
                      });
                      this.$store.commit('d2admin/menu/asideSet', _side2.length > 0 ? _side2[0].children : []);
                    }
                  }

                  this.$store.commit('d2admin/menu/asideSet', menuAside);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function handler(_x, _x2) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }(),
      immediate: true
    }
  }
}).$mount('#app');